import './styles.css'

import { Button } from "@fragments";
import { ArrowForwardRounded } from '@mui/icons-material'

export default function BottomSubmit({ onPress }) {
    return (
        <div className='bottom-submit'>
            <small className='text'>
                Alterações não salvas
            </small>
            <Button
                onClick={onPress}
                variant='contained'
                className='bottom-submit-btn'
                size='small'
                endIcon={<ArrowForwardRounded />}
            >
                Salvar
            </Button>
        </div>
    )
}